import { createApp, h } from 'vue'
import './registerServiceWorker'

import App from './App.vue'
import router from './router'
import i18n from './i18n'

import AppIcon from '@/components/atoms/AppIcon.vue'
import AppButton from '@/components/atoms/AppButton.vue'
import AppLoader from '@/components/atoms/AppLoader.vue'
import AppContent from '@/components/layout/AppContent.vue'
import AppModal from '@/components/ui/AppModal.vue'

import registerDirectives from '@/directives'
import registerFilters from '@/filters'

// Create app
const app = createApp({
  render: () => h(App)
})

// Register plugins
app.use(router)
app.use(i18n)

// Register components
app.component('Modal', AppModal)
app.component('AppIcon', AppIcon)
app.component('AppButton', AppButton)
app.component('AppLoader', AppLoader)
app.component('AppContent', AppContent)

// Register directives
registerFilters(app)
registerDirectives(app)

// Mount app
app.mount('#app-wrapper')

export default app